import React from 'react';
import SEOHelmet from '../SEOHelmet';

const BishanpuraPage: React.FC = () => {
  React.useEffect(() => {
    window.scrollTo(0, 0);
    //eslint-disable-next-line
  }, []);
  
  return (
    <div className='mt-28 mb-20 max-w-4xl mx-auto px-4'>
      <SEOHelmet />
      <h1 className='text-3xl md:text-5xl font-bold text-center mb-8'>Neurosurgical Consultations for Bishanpura | Dr. Gangesh Gunjan</h1>
      
      <section className='mb-8'>
        <h2 className='text-2xl md:text-3xl font-semibold mb-4'>Specialized Neurosurgical Care for Bishanpura Patients</h2>
        <p className='text-lg text-gray-700 leading-relaxed'>Dr. Gangesh Gunjan provides comprehensive neurosurgical evaluation and clinical care for patients travelling from Bishanpura. Practicing at Sarvodaya Hospital, Greater Noida West, Dr. Gunjan focuses on evidence-based treatment pathways for complex brain, spine, and peripheral nerve conditions.</p>
      </section>

      <section className='mb-8'>
        <h2 className='text-2xl md:text-3xl font-semibold mb-4'>Comprehensive Neurosurgical Services</h2>
        <ul className='list-disc pl-6 text-lg text-gray-700 space-y-3'>
          <li><strong>Brain Tumor & Cranial Surgery</strong>
            <ul className='list-circle pl-6 mt-1 space-y-1 text-base'>
              <li>Awake craniotomy for eloquent cortex tumors</li>
              <li>Endoscopic transsphenoidal procedures for pituitary lesions</li>
              <li>Intraoperative neurophysiological monitoring</li>
            </ul>
          </li>
          <li><strong>Spine Disorder Management</strong>
            <ul className='list-circle pl-6 mt-1 space-y-1 text-base'>
              <li>Minimally invasive spine surgery (MISS)</li>
              <li>Microdiscectomy and spinal decompression</li>
              <li>Stabilization and deformity management</li>
            </ul>
          </li>
          <li><strong>Neurovascular & Trauma Care</strong>
            <ul className='list-circle pl-6 mt-1 space-y-1 text-base'>
              <li>Evaluation of intracranial aneurysms and vascular malformations</li>
              <li>Acute neurotrauma and head injury management</li>
              <li>Intracranial hemorrhage stabilization</li>
            </ul>
          </li>
          <li><strong>Pediatric Neurosurgery</strong>
            <ul className='list-circle pl-6 mt-1 space-y-1 text-base'>
              <li>Evaluation of hydrocephalus and shunt procedures</li>
              <li>Spinal dysraphism and congenital malformations</li>
              <li>Pediatric cranial tumor evaluations</li>
            </ul>
          </li>
        </ul>
      </section>

      <section className='mb-8'>
        <h2 className='text-2xl md:text-3xl font-semibold mb-4'>Clinical Care Standards & Approach</h2>
        <ul className='list-disc pl-6 text-lg text-gray-700 space-y-2'>
          <li>Over 12 years of specialized neurosurgical experience</li>
          <li>Emphasis on conservative management before recommending surgical interventions</li>
          <li>Utilization of modern microsurgical tools and neuronavigation systems</li>
          <li>Structured diagnostic evaluation and clear treatment counseling</li>
          <li>Multidisciplinary coordination with critical care and neuro-rehabilitation</li>
        </ul>
      </section>

      <section className='mb-8'>
        <h2 className='text-2xl md:text-3xl font-semibold mb-4'>Diagnostic & Surgical Infrastructure</h2>
        <p className='text-lg text-gray-700 mb-3'>Consultations and procedures are conducted at Sarvodaya Hospital, Greater Noida West, supported by:</p>
        <ul className='list-disc pl-6 text-lg text-gray-700 space-y-2'>
          <li>Advanced neuroimaging (high-resolution MRI and CT diagnostics)</li>
          <li>Optical neuronavigation platforms for cranial and spinal localization</li>
          <li>Intraoperative neurophysiological monitoring (IONM)</li>
          <li>High-definition neurosurgical operating microscopes</li>
          <li>Dedicated Neuro-Intensive Care Unit (Neuro-ICU)</li>
        </ul>
      </section>

      <section className='mb-8'>
        <h2 className='text-2xl md:text-3xl font-semibold mb-4'>Patient-Centric Clinical Protocol</h2>
        <div className='text-lg text-gray-700'>
          <p className='mb-2'>Dr. Gunjan and the clinical team prioritize transparent communication and patient well-being:</p>
          <ul className='list-disc pl-6 space-y-2'>
            <li>Detailed pre-operative counseling detailing surgical indications and alternatives</li>
            <li>Informed consent discussions outlining realistic recovery milestones</li>
            <li>Structured post-operative care and rehabilitation plans</li>
            <li>Scheduled follow-up evaluations to monitor clinical progress</li>
          </ul>
        </div>
      </section>

      <section className='mb-8 bg-blue-50 p-6 rounded-2xl border border-blue-100'>
        <h2 className='text-2xl md:text-3xl font-semibold mb-3 text-blue-900'>Consultation Details for Bishanpura Residents</h2>
        <p className='text-lg text-gray-700 leading-relaxed mb-4'>
          To schedule a neurosurgical evaluation with Dr. Gangesh Gunjan, please call{' '}
          <a href="tel:+917727834367" className='text-blue-600 font-semibold hover:underline'>+91-7727834367</a>{' '}
          or visit the Department of Neurosurgery (Room no. 1011), Sarvodaya Hospital, Sector 16C, Gaur City 2, Greater Noida West.
        </p>
      </section>
    </div>
  );
};

export default BishanpuraPage;